var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77778 13.5H1L13.5 1L26 13.5H23.2222M3.77778 13.5V23.2222C3.77778 23.9589 4.07044 24.6655 4.59137 25.1864C5.1123 25.7073 5.81884 26 6.55556 26H20.4444C21.1812 26 21.8877 25.7073 22.4086 25.1864C22.9296 24.6655 23.2222 23.9589 23.2222 23.2222V13.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 26V17.6667C9.33325 16.93 9.62591 16.2234 10.1468 15.7025C10.6678 15.1815 11.3743 14.8889 12.111 14.8889H14.8888C15.6255 14.8889 16.3321 15.1815 16.853 15.7025C17.3739 16.2234 17.6666 16.93 17.6666 17.6667V26",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeicon);
export default __webpack_public_path__ + "static/media/home icon.230e9c0f9d2004d3bb61d56c88e54081.svg";
export { ForwardRef as ReactComponent };